// Progressive enhancement: add a data-hoverable flag only for pointer-fine devices.
// This prevents any accidental sticky hover on touch devices.
(function() {
  try {
    var isFine = window.matchMedia('(pointer:fine)').matches;
    document.documentElement.classList.toggle('bubl-pointer-fine', isFine);
  } catch (e) {}
})();

// Optional: If you want keyboard focus on the media link to trigger the reveal,
// CSS :focus-within already handles it. No additional JS needed.
